var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0C2.90969 0 0 2.91053 0 6.49976C0 10.0899 2.90993 13 6.5 13C10.0898 13 13 10.0899 13 6.49976C13 2.91053 10.0898 0 6.5 0ZM6.5 0.732613C9.67982 0.732613 12.2673 3.32004 12.2673 6.49974C12.2673 9.67992 9.67982 12.2673 6.5 12.2673C3.31971 12.2673 0.732663 9.67992 0.732663 6.49974C0.732663 3.32004 3.31971 0.732613 6.5 0.732613Z",
    fill: "#D30202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10002 3.8999L3.90002 9.09971",
    stroke: "#D30202",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90002 3.8999L9.10002 9.09971",
    stroke: "#D30202",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/RejectedIcon.113b8d7e079bf1ba43d70390057ffec3.svg";
export { ForwardRef as ReactComponent };